var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"account-details-container"},[(_vm.listItemChosen == _vm.listItemsTitle[0].value)?_c('account-settings'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }